export { InjectedConnector } from 'wagmi-private';
